<template>
    <section class="app-main">
        <transition name="fade-transform"
                    mode="out-in">
            <router-view :key="key" />
        </transition>
    </section>
</template>

<script>
export default {
    name: 'AppMain',
    computed: {
        key () {
            return this.$route.path
        }
    }
}
</script>

<style lang="scss" scoped>
.app-main {
    // width: 1100px;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
}
</style>
